module.exports = __webpack_public_path__ + "static/img/onlinestore3.890bfb2.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/onlinestore3.jpeg
// module id = 670
// module chunks = 1